export default "<router-outlet></router-outlet>\n<app-spinner></app-spinner>";